export default Object.freeze({
  activities: [
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis. ',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      pinned: true,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Property Viewed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis. ',
      pinned: true,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Favorite Property Removed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Search Performed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Property Viewed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Favorite Property Removed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Search Performed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet.',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Favorite Property Removed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Search Performed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Email Opened',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      email_threads: [
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Opened',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
        {
          type: 'Email Sent',
          user: 'lorem.ipsum@hotmail.com',
          created_at: '2020-06-24T18:41:09.000Z',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
          opens: '3',
          clicks: '2'
        },
      ],
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      opens: '3',
      clicks: '2',
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Property Viewed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
    {
      type: 'Favorite Property Removed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Search Performed',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum nulla ipsum, viverra eu odio et, porta varius metus. Mauris tincidunt',
      pinned: false,
      isEditable: false,
      isRemovable: false,
    },
    {
      type: 'Comment',
      created_at: '2020-06-24T18:41:09.000Z',
      user: {
        first_name: 'LionDesk',
        last_name: 'Development'
      },
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet iaculis tellus sit amet tempus. Nulla auctor nulla in orci mollis convallis. Quisque tempor efficitur velit, id aliquet erat egestas sit amet. Maecenas id eleifend elit, sit amet pretium quam. Aenean vel libero turpis.',
      pinned: false,
      isEditable: true,
      isRemovable: true,
    },
  ],

  activityTypes: [
    {
      type: 'Property Viewed',
      icon: 'home',
    },
    {
      type: 'Favorite Property Removed',
      icon: 'home',
    },
    {
      type: 'Search Performed',
      icon: 'search',
    },
    {
      type: 'User Login',
      icon: 'login',
    },
    {
      type: 'Saved Search Added',
      icon: 'save',
    },
    {
      type: 'Valuation Inquiry',
      icon: 'stay_primary_portrait',
    },
    {
      type: 'Email Opened',
      icon: 'email',
    },
    {
      type: 'Contact Comments',
      icon: 'comment',
    },
    {
      type: 'Texts',
      icon: 'stay_primary_portrait',
    }
  ],

  iconsList: [
    {
      icon: 'push_pin',
      text: 'Pins',
    }, 
    {
      icon: 'home',
      text: '5 Visits',
    },
    {
      icon: 'comment',
      text: '4 Comments',
    },
    {
      icon: 'phone',
      text: '8 Calls',
    }, 
    {
      icon: 'stay_primary_portrait',
      text: '9 Texts',
    },
    {
      icon: 'email',
      text: '4 Emails',
    }
  ],

  profile: {
    name: 'LionDesk Devteam',
    last_activity_time: 'Last activity time 20 minutes ago',
    cards: [
      {
        board_id: 'left',
        card_title: 'Primary Details',
        card_action: '',
        card_id: 'primary_details',
        order: 1,
        fields: [
          {
            field_name: 'Source',
            field_value: 'Lorem Lorem Lorem',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Type',
            field_value: 'Buyer',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Status',
            field_value: 'Prospecting',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Assigned to',
            field_value: 'Prospecting',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Shared With',
            field_value: 'Jason Smith, LionDes Team',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Owner',
            field_value: 'David Anderson',
            type: 'text',
            icon: ''
          },
        ]
      },
      {
        board_id: 'left',
        card_title: 'Custom Fields',
        card_action: '',
        card_id: 'custom_fields',
        order: 2,
        fields: []
      },
      {
        board_id: 'left',
        card_title: 'Spouse Information',
        card_action: '',
        card_id: 'spouse_information',
        order: 3,
        fields: [
          {
            field_name: 'Spouse Name',
            field_value: 'Cecilia Clarkson',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Spouse Email',
            field_value: 'algo@lgo.com',
            type: 'email',
            icon: ''
          },
          {
            field_name: 'birthday',
            field_value: '05/05/1955',
            type: 'text',
            icon: ''
          },
        ]
      },
      {
        board_id: 'left',
        card_title: 'Addresses',
        card_action: '+ Add',
        card_id: 'adresses',
        order: 5,
        addresses: [
          {
            fields: [
              {
                field_name: 'Address type',
                field_value: 'Main office',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 1',
                field_value: '267 Gislason Fords Suite 956',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 2',
                field_value: '67 Hessel Key Suite 777',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'City',
                field_value: 'East Brayan',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'State',
                field_value: 'CA',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Zip/Postal',
                field_value: '92708',
                type: 'text',
                icon: ''
              },
            ]
          },
          {
            fields: [
              {
                field_name: 'Address type',
                field_value: 'Main office',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 1',
                field_value: '267 Gislason Fords Suite 956',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 2',
                field_value: '67 Hessel Key Suite 777',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'City',
                field_value: 'East Brayan',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'State',
                field_value: 'CA',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Zip/Postal',
                field_value: '92708',
                type: 'text',
                icon: ''
              },
            ]
          },
          {
            fields: [
              {
                field_name: 'Address type',
                field_value: 'Main office',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 1',
                field_value: '267 Gislason Fords Suite 956',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Address 2',
                field_value: '67 Hessel Key Suite 777',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'City',
                field_value: 'East Brayan',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'State',
                field_value: 'CA',
                type: 'text',
                icon: ''
              },
              {
                field_name: 'Zip/Postal',
                field_value: '92708',
                type: 'text',
                icon: ''
              },
            ]
          },
        ]
      },
      {
        board_id: 'right',
        card_title: 'Leads History',
        card_action: '+ Add',
        card_id: 'leads_history',
        order: 0,
        fields: []
      },
      {
        board_id: 'right',
        card_title: 'Contact List',
        card_action: '+ Add',
        card_id: 'contact_list',
        order: 1,
        fields: [
          {
            field_name: '',
            field_value: 'Buyers',
            type: 'text',
            icon: ''
          },
          {
            field_name: '',
            field_value: 'Sphere of Hot Clients',
            type: 'text',
            icon: ''
          },
        ]
      },
      {
        board_id: 'right',
        card_title: 'Documents',
        card_action: '+ Add',
        card_id: 'documents',
        order: 2,
        fields: []
      },
      {
        board_id: 'right',
        card_title: '3rd Party Integrations',
        card_action: '',
        card_id: '3rd_party_integrations',
        order: 3,
        fields: []
      },
      {
        board_id: 'right',
        card_title: 'Associated Parties',
        card_action: '',
        card_id: 'associated_parties',
        order: 4,
        fields: [
          {
            field_name: 'Lender',
            field_value: 'David anderson david@liondesk.com',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Buyers Agent',
            field_value: 'Lee Ling Yang leeling@liondesk.com',
            type: 'text',
            icon: ''
          },
          {
            field_name: 'Title',
            field_value: 'Alliance Escrow - David Anderson',
            type: 'text',
            icon: ''
          },
        ]
      },
      {
        board_id: 'right',
        card_title: 'Website Activity',
        card_action: '',
        card_id: 'website_activity',
        order: 5,
        fields: []
      },
      {
        board_id: 'right',
        card_title: 'Adversiting',
        card_action: '',
        card_id: 'adversiting',
        order: 6,
        fields: []
      },

    ]
  }

});
